import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Loaderbar from "./loaderbar";

function Loader({ children }) {
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    const timeout = setTimeout(() => {
      setLoading(false);
    }, 500); 

    return () => clearTimeout(timeout);
  }, [location]);

  return (
    <>
      {loading && <Loaderbar />}
      {children}
    </>
  );
}

export default Loader;